import { render } from "./MessageThreads.vue?vue&type=template&id=5342ea5a&scoped=true"
import script from "./MessageThreads.vue?vue&type=script&lang=js"
export * from "./MessageThreads.vue?vue&type=script&lang=js"

import "./MessageThreads.vue?vue&type=style&index=0&id=5342ea5a&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5342ea5a"]])

export default __exports__